import React from 'react';
import { Tab } from 'react-bootstrap5';

import routes from 'app/routes';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import { useContext } from 'components/Managers/Dashboard/Context';
import useApiData from 'components/Managers/Dashboard/Hooks/useApiData';
import Pagination from './Pagination';

export default function Index() {
  const { state: { filters } } = useContext();
  const route = routes.api.managers.dashboard.member_feedback;
  const { data, loading } = useApiData(route, filters);

  const firstId = data[0]?.id;
  const eventKey = (id) => `member-feedback-${id}`;

  const tabs = data.map((feedback) => (
    <Tab.Content key={eventKey(feedback.id)}>
      <Tab.Pane eventKey={eventKey(feedback.id)}>
        {feedback.attributes.feedback.answer}
      </Tab.Pane>
    </Tab.Content>
  ));

  return (
    <section>
      <h3>Member Feedback</h3>

      {loading ? <LoadingPlaceholder className="py-4" /> : (
        <Tab.Container id="member-feedback" defaultActiveKey={eventKey(firstId)}>
          <div className="fw-light">
            {tabs}
          </div>

          {data.length > 0 && (
            <Pagination feedbacks={data} eventKey={eventKey} />
          )}
        </Tab.Container>
      )}
    </section>
  );
}
